import React from 'react';

import { SVGPropsType } from 'src/types';
const Hot = (props: SVGPropsType) => {
    const { fill = '#E73E6B', onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.11 4.33998C11.44 6.29998 12.62 8.70998 11.35 11.05C10.85 11.97 10.02 12.71 9.04003 13.11C8.07003 13.51 6.97003 13.56 5.94003 13.35C4.95003 13.15 4.00003 12.69 3.30003 11.96C1.71003 10.29 1.77003 7.68998 3.13003 5.91998C3.58003 5.32998 4.13003 4.82998 4.71003 4.35998C5.11003 4.02998 5.53003 3.70998 5.90003 3.33998C6.55003 2.69998 6.85003 1.69998 7.06003 0.839976C7.08003 0.759976 7.09003 0.659976 7.10003 0.599976C8.17003 1.83998 8.70003 3.51998 8.62003 5.14998C8.59003 5.62998 8.52003 6.09998 8.42003 6.56998C8.33003 6.97998 8.29003 7.19998 8.09003 7.78998C8.62003 7.52998 9.08003 6.84998 9.22003 6.64998C9.58003 6.12998 10.01 4.97998 10.08 4.33998H10.11Z"
                fill={fill}
            />
        </svg>
    );
};
export default Hot;
